module.exports = __webpack_public_path__ + "media/images/CRUISEHD-a696f946.jpg";